export const PREVIEW_BAR_CLASS = 'box-preview';

export const getPreviewBarHeight = (): number =>
    document.querySelector<HTMLElement>(`.${PREVIEW_BAR_CLASS}`)
        ?.offsetHeight ?? 0;
